import { Box, Text, Flex } from "@chakra-ui/layout";
import colors from "core/resources/theme/colors";

interface FieldShowProps {
  label: string;
  value: string;
  icone?: any;
}

export default function FieldShow({ label, value, icone }: FieldShowProps) {
  return (
    <Box>
      {label ? (
        <Box>
          <Text fontSize="14px">{label}</Text>
        </Box>
      ) : null}

      <Flex
        bg={colors.lightGray}
        rounded={5}
        h={8}
        align="center"
        justifyContent="space-between"
        px={4}
      >
        <Text fontSize="14px">{value}</Text>
        {icone}
      </Flex>
    </Box>
  );
}
